import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import { DataSharingService } from 'src/app/services/data-sharing/data-sharing.service';
import { GlobalsService } from 'src/app/services/globals/globals.service';

@Component({
  selector: 'app-side-nav-content',
  templateUrl: './side-nav-content.component.html',
  styleUrls: ['./side-nav-content.component.scss']
})
export class SideNavContentComponent implements OnInit {

  user: any;

  navItems = [];


  constructor(
    private router: Router,
    private dataSharingService: DataSharingService,
    private api: ApiService
  ) {
    this.dataSharingService.isUserUpdate.subscribe(value => {
      if (value === true) {
        this.autoUpdateData()
      }
    });
  }


  async ngOnInit() {
    if(window.innerWidth == 768){
      this.navItems = [{ label: 'Home', route: '/' },
        { label: 'Fund Request', route: '/fund-request' },
        { label: 'Liquidation', route: '/liquidation' },
        { label: 'Scholarship', route: '/scholarship' },
        { label: 'Personal', route: '/personal-information' },
        { label: 'Academic', route: '/academic' },
        { label: 'Commitments', route: '/commitments' },
        { label: 'FAQ', route: '/faq' },
        { label: 'Contact Real LIFE', route: '/contact-us' },
      ];
    }else{
      this.navItems = [{ label: 'Home', route: '/' },
        { label: 'Fund Request', route: '/fund-request' },
        { label: 'Liquidation', route: '/liquidation' },
        { label: 'Scholarship', route: '/scholarship' },
        { label: 'Personal', route: '/personal-information' },
        { label: 'Academic', route: '/academic' },
        { label: 'Commitments', route: '/commitments' },
        { label: 'FAQ', route: '/faq' },
        { label: 'Contact Real LIFE', route: '/contact-us' },
        // { label: 'Logout', route: '/login' },
        
      ];
    }
    if (localStorage.length !== 0) {
      if (JSON.parse(localStorage.getItem('user_info')) || JSON.parse(localStorage.getItem('user_info')) !== null) {
        const user_data = await JSON.parse(localStorage.getItem('user_info'))
        await this.getScholarData(user_data.user_id)
      }

      const image: any = `${GlobalsService.baseUrl2}/open_attachment/${this.user.photo}?data`
      fetch(image).then(response => response.json())
        .then(data => this.user.photo = data.source);
    }

  }

  async autoUpdateData() {
    const user_data = await JSON.parse(localStorage.getItem('user_info'))
    await this.getScholarData(user_data.user_id)
  }

  onNavigationSelection(navItem: any) {
    this.router.navigate([navItem.route]);
  }

  goToPersonalInfo() {
    this.router.navigate(['/personal-information'])
  }

  async getScholarData(id) {
    try {

      const rawToken = localStorage.getItem('session_id')
      const token = btoa(rawToken + ':')

      // var data = {
      //   'request': "GET",
      //   'item[0]': "scholars",
      //   'item[1]': id
      // }

      const res: any = await this.api.getSpecificScholarData2(token, id)
      this.user = res
      localStorage.setItem('user', JSON.stringify(res))
    } catch (error) {
      // setTimeout(() => {
      //   if (error.status === 403) {
      //     this.showSessionExpired = true
      //     this.route.navigate(['/login'])
      //   }
      // }, 2000);
    }

  }

}
